export const residueManagementGraphTheme = {
    color: ['#84C19F', '#FDD980'],
};
